/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerDocumentErrorMetadata } from './ScreenerDocumentErrorMetadata';
import {
    ScreenerDocumentErrorMetadataFromJSON,
    ScreenerDocumentErrorMetadataFromJSONTyped,
    ScreenerDocumentErrorMetadataToJSON,
} from './ScreenerDocumentErrorMetadata';

/**
 * 
 * @export
 * @interface ScreenerDocumentError
 */
export interface ScreenerDocumentError {
    /**
     * 
     * @type {string}
     * @memberof ScreenerDocumentError
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerDocumentError
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerDocumentError
     */
    document_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerDocumentError
     */
    error_type: ScreenerDocumentErrorErrorTypeEnum;
    /**
     * 
     * @type {ScreenerDocumentErrorMetadata}
     * @memberof ScreenerDocumentError
     */
    metadata?: ScreenerDocumentErrorMetadata;
    /**
     * 
     * @type {Date}
     * @memberof ScreenerDocumentError
     */
    dismissed_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScreenerDocumentError
     */
    recovered_at?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScreenerDocumentError
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScreenerDocumentError
     */
    updated_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScreenerDocumentError
     */
    deleted_at?: Date;
}


/**
 * @export
 */
export const ScreenerDocumentErrorErrorTypeEnum = {
    SkippedPackageLimitExceeded: 'SKIPPED_PACKAGE_LIMIT_EXCEEDED',
    DownloadError: 'DOWNLOAD_ERROR',
    DownloadErrorEcl: 'DOWNLOAD_ERROR_ECL',
    DocumentTooLarge: 'DOCUMENT_TOO_LARGE',
    DocumentNotRelevant: 'DOCUMENT_NOT_RELEVANT',
    InvalidDocumentType: 'INVALID_DOCUMENT_TYPE',
    DocumentOutsideReviewWindow: 'DOCUMENT_OUTSIDE_REVIEW_WINDOW',
    ProcessingError: 'PROCESSING_ERROR'
} as const;
export type ScreenerDocumentErrorErrorTypeEnum = typeof ScreenerDocumentErrorErrorTypeEnum[keyof typeof ScreenerDocumentErrorErrorTypeEnum];


/**
 * Check if a given object implements the ScreenerDocumentError interface.
 */
export function instanceOfScreenerDocumentError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "error_type" in value;

    return isInstance;
}

export function ScreenerDocumentErrorFromJSON(json: any): ScreenerDocumentError {
    return ScreenerDocumentErrorFromJSONTyped(json, false);
}

export function ScreenerDocumentErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerDocumentError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'document_id': !exists(json, 'document_id') ? undefined : json['document_id'],
        'error_type': json['error_type'],
        'metadata': !exists(json, 'metadata') ? undefined : ScreenerDocumentErrorMetadataFromJSON(json['metadata']),
        'dismissed_at': !exists(json, 'dismissed_at') ? undefined : (new Date(json['dismissed_at'])),
        'recovered_at': !exists(json, 'recovered_at') ? undefined : json['recovered_at'],
        'created_at': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updated_at': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'deleted_at': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}

export function ScreenerDocumentErrorToJSON(value?: ScreenerDocumentError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'document_id': value.document_id,
        'error_type': value.error_type,
        'metadata': ScreenerDocumentErrorMetadataToJSON(value.metadata),
        'dismissed_at': value.dismissed_at === undefined ? undefined : (value.dismissed_at.toISOString()),
        'recovered_at': value.recovered_at,
        'created_at': value.created_at === undefined ? undefined : (value.created_at.toISOString()),
        'updated_at': value.updated_at === undefined ? undefined : (value.updated_at.toISOString()),
        'deleted_at': value.deleted_at === undefined ? undefined : (value.deleted_at.toISOString()),
    };
}

